<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="grid">
        <div class="col-12">
          <div class="formgrid grid">
            <div class="field col-12 md:col-12">
              <label>Kode Divisi (Opsional)</label>
              <InputText
                ref="ctg"
                v-model="form.ctg"
                class="w-full"
                input-class="w-full"
                maxlength="2"
                placeholder
                @keydown="handleKeydownField($event, 'name')"
              />
              <small
                v-if="
                  this.editMode == true &&
                  (this.form.ctg == '' || this.form.ctg == null)
                "
                class="p-error"
                >Kode divisi tidak boleh kosong</small
              >
              <small class="text-500">
                Kode otomatis dibuat sistem, tetapi masih dapat diubah.
              </small>
            </div>
            <div class="field col-12 md:col-12">
              <label>Nama Divisi</label>
              <InputText
                ref="name"
                v-model="form.name"
                :class="{ 'p-invalid': v$.form.name.$invalid && submitted }"
                class="w-full"
                input-class="w-full"
                maxlength="40"
                @keydown="handleKeydownField($event, 'btnSave')"
              />
              <small
                v-if="
                  (v$.form.name.$invalid && submitted) ||
                  v$.form.name.$pending.$response
                "
                class="p-error"
                >{{ v$.form.name.required.$message }}</small
              >
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-content-end align-items-end">
        <Button
          label="Tutup"
          icon="pi pi-times"
          @click="$emit('close')"
          class="p-button-text mr-2"
        />
        <Button
          :loading="loading"
          label="Simpan"
          icon="pi pi-check"
          type="submit"
          ref="btnSave"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { focusNextField, handleKeydownField } from '@/helpers'
import DivisiService from '@/services/DivisiService'
import useVuelidate from '@vuelidate/core'
import { helpers, required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      submitted: false,
    }
  },
  created() {
    this.divisiService = new DivisiService()
  },
  async mounted() {
    if (!this.editMode) {
      const res = await this.divisiService.generateCode()
      this.form.ctg = res.data.ctg
    }
    this.$nextTick(() => {
      setTimeout(() => {
        focusNextField(this, 'ctg')
      }, 100)
    })
  },
  computed: {
    form() {
      return this.item
    },
  },
  methods: {
    handleSubmit(isFormValid) {
      this.submitted = true

      if (
        this.editMode == true &&
        (this.form.ctg == '' || this.form.ctg == null)
      ) {
        return
      }

      if (!isFormValid) {
        return
      }

      this.$emit('save', this.form)
    },
    handleKeydownField(event, nextRef, selectAll = false) {
      handleKeydownField(this, event, nextRef, selectAll)
    },

    focusNextField(refName, selectAll = false) {
      focusNextField(this, refName, selectAll)
    },
  },
  validations() {
    return {
      form: {
        name: {
          required: helpers.withMessage('Nama harus diisi.', required),
        },
      },
    }
  },
}
</script>
